module.exports = __webpack_public_path__ + "img/person_search_opsz24.fe8002ae.svg";